import { render, staticRenderFns } from "./upFace.vue?vue&type=template&id=18cb1772&scoped=true&"
import script from "./upFace.vue?vue&type=script&lang=js&"
export * from "./upFace.vue?vue&type=script&lang=js&"
import style0 from "./upFace.vue?vue&type=style&index=0&id=18cb1772&lang=scss&scoped=true&"
import style1 from "./upFace.vue?vue&type=style&index=1&id=18cb1772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cb1772",
  null
  
)

export default component.exports